import "./Footer.scss";

const Footer = () => {
  return (
    <footer>
      <p className="footer__sign-up">Sign up for my mailing list!</p>

      <form
        className="footer__form"
        method="post"
        action="https://www.aweber.com/scripts/addlead.pl"
      >
        <div style={{ display: "none" }}>
          <input type="hidden" name="meta_web_form_id" value="930397788" />
          <input type="hidden" name="meta_split_id" value="" />
          <input type="hidden" name="listname" value="awlist5882397" />
          <input
            type="hidden"
            name="redirect"
            value="https://www.aweber.com/thankyou-coi.htm?m=text"
            id="redirect_4e8f5fc3d9979a52300430bb7959f745"
          />

          <input
            type="hidden"
            name="meta_adtracking"
            value="LowKeyBakerr_Subscription"
          />
          <input type="hidden" name="meta_message" value="1" />
          <input type="hidden" name="meta_required" value="email" />

          <input type="hidden" name="meta_tooltip" value="" />
        </div>

        <input
          type="text"
          name="email"
          value=""
          placeholder="Email"
          className="footer__input"
        />
        <input
          type="submit"
          name="submit"
          value="Subscribe"
          className="footer__button"
        />
      </form>
      <p className="footer__signature">Baked and Developed by Sarah Mahmood</p>
    </footer>
  );
};

export default Footer;
